import '.g8{border-left:4px solid var(--gray-200);}.ssr-plugin'
import '.g9{padding-left:1.5rem;}.ssr-plugin'
import '.ga{margin:1rem 0;}.ssr-plugin'
import '.gb{color:var(--gray-700);}.ssr-plugin'
import '.gc{font-style:italic;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { PropsWithChildren } from 'react'

interface BlockQuoteProps extends PropsWithChildren {
  style?: Style
}

export const BlockQuote = ({ children, style }: BlockQuoteProps) => {
  return (
    <styled.blockquote className="g8 g9 ga gb gc"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.blockquote>
  )
}
